import { Injectable } from '@angular/core';
import { omit } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  private _questionnaire: Array<any> = [];

  constructor() { }

  set questionnaire(payload) {
    this._questionnaire = payload;
  }

  get questionnaire() {
    return this._questionnaire;
  }

  /**
   * Format questionnaire data in
   * the desired format
   * @param questionnaire raw data from forms
   */
  setQuestionnairePayload(questionnaire) {
    const payload = questionnaire.map((question, index) => {

      const _item = omit(question, 'questionType');
      _item.sortIndex = index + 1;

      if (question.answerOptions)
        _item.answerOptions = question.answerOptions
          .map((option, j) => {

            return {
              sortIndex: j + 1,
              ...option
            };
          });

      return _item;
    });


    return payload;
  }

  makeRequestPayload(questionnaire) {
    const payload = questionnaire.map((question, index) => {

      const _item = omit(question, ['questionType', 'questionTypeConst', 'sortIndex']);
      // _item.sortIndex = index + 1;

      if (question.answerOptions)
        _item.answerOptions = question.answerOptions
          .map((option, j) => {
            return option.availableAnswerText;
          });

      return _item;
    });

    return payload;

  }
}
